import { Link } from 'react-router-dom'
import React from "react";

export function AdapterLink ({ url, ...rest }) {
  return <Link to={url} {...rest} />
}